import React from "react";
import { useTranslation } from "@emisgroup/acp-application-intl";
import { Button, Table, TableProps } from "../../../Common/UI/Index";
import { ButtonVariantType } from "../../../Common/UI/Types";
import { NoExecutionIcon } from "./NoExecutionIcon";
import Add from "~icons/ic/baseline-add-circle";
import "./Style.scss";

interface IExecutionListListViewProps {
  onAddExecutionClick: () => void;
  onRowSelected: (e: React.MouseEvent) => void;
  executionList: TableProps;
}

// Responsible for rendering execution list
export const ExecutionListView: React.FC<IExecutionListListViewProps> = ({ onAddExecutionClick,
  onRowSelected, executionList }) => {

  const { t: translate } = useTranslation();

  return (
    <div className="execution-list">
      <div className="execution-list__add-btn">
        <Button
          id="addNewExecutionButton"
          data-testid="addNewExecutionButton"
          variant={ButtonVariantType.FILLED}
          onClick={onAddExecutionClick}
        >
          <Add title="add"/>
          {translate("Button.AddExecution")}
        </Button>
      </div>
      <div className="execution-list__label">
        <h2>{translate("ExecutionList.ExecutionHistory")}</h2>
      </div>
      {executionList.dataRow?.length === 0 && (
        <div>
          <div className="execution-list__no-execution-icon">
            <NoExecutionIcon/>
          </div>
          <div className="execution-list__no-execution-main-message">
            {translate("ExecutionList.NoExecutions.Title")}
          </div>
          <div className="execution-list__no-execution-description">
            {translate("ExecutionList.NoExecutions.Description")}
          </div>
        </div>
      )}
      {executionList.dataRow?.length > 0 && (
        <div className="executions-table">
          <Table
            id="executionsTable"
            tableData={executionList}
            emptyStateText=""
            data-testid="executionsTable"
            onRowSelected={onRowSelected}
          />
        </div>
      )}
    </div>
  );
};
